import axios from '@/axiosInterceptor';

const state = () => ({
  selectedCarrierId: null, // the carrier they are trying to onboard
  dispatchServiceCompanyName: '',
});

// getters
const getters = {};

// actions
const actions = {
  async createDispatcherConnection(_, data) {
    let body = {
      dispatcher_connection: data,
    };
    // let formData = new FormData();
    // formData.append('dispatcher_connection[carrier_id]', body.carrier_id);
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/dispatcher_connections',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setSelectedCarrierId(state, carrierId) {
    state.selectedCarrierId = carrierId;
  },
  setDispatchServiceCompanyName(state, companyName) {
    localStorage.setItem('dispatchServiceCompanyName', companyName);
    state.dispatchServiceCompanyName = companyName;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
